export enum eventResponseStatus {
  WAITING = 'waiting',
  DECLINED = 'declined',
  ACCEPTED = 'accepted',
  TENTATIVE = 'tentative',
  BLOCKED = 'blocked',
}
